// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__8ZySf","info":"PatientInfo_info__sbJCA"};